module.exports = __webpack_public_path__ + "img/sunset-road.62b97df3.jpg";